import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconArrowAlignHorizontalCentre16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconArrowAlignHorizontalCentre16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M8.5 1.5a.5.5 0 0 0-1 0v3.343L6.054 3.396a.5.5 0 1 0-.708.708l2.299 2.298.353.353.354-.353 2.298-2.298a.5.5 0 0 0-.707-.708L8.5 4.84zM2 8a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11A.5.5 0 0 1 2 8m5.996 7a.5.5 0 0 1-.5-.5v-3.339l-1.443 1.443a.5.5 0 0 1-.707-.708l2.298-2.298.354-.353.354.353 2.298 2.298a.5.5 0 0 1-.707.708l-1.447-1.447V14.5a.5.5 0 0 1-.5.5"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconArrowAlignHorizontalCentre16);
